'use client';

import Image from 'next/image';
import {useFormatNumber, useI18n} from '@udemy-v2/i18n';

import styles from './partner-logos.module.scss';

const APPROX_COMPANY_COUNT = 17000;

export const cdnSrc = (path: string) => {
    const prefix = process.env.ASSET_PREFIX ?? '';
    return prefix.startsWith('http') ? `${prefix.replace(/\/$/, '')}${path}` : path;
};

const PARTNER_LOGOS = [
    {src: cdnSrc('/partner-logos/nasdaq.png'), alt: 'Nasdaq', width: 110, height: 24},
    {src: cdnSrc('/partner-logos/mattel.png'), alt: 'Mattel', width: 52, height: 36},
    {src: cdnSrc('/partner-logos/cisco.png'), alt: 'Cisco', width: 90, height: 48},
    {src: cdnSrc('/partner-logos/fender.png'), alt: 'Fender', width: 90, height: 48},
    {
        src: cdnSrc('/partner-logos/publicis-sapient.png'),
        alt: 'Publicis Sapient',
        width: 80,
        height: 36,
    },
    {src: cdnSrc('/partner-logos/vimeo.png'), alt: 'Vimeo', width: 80, height: 28},
    {src: cdnSrc('/partner-logos/samsung.png'), alt: 'Samsung', width: 110, height: 24},
    {src: cdnSrc('/partner-logos/citi.png'), alt: 'Citi', width: 52, height: 36},
];

export function PartnerLogos() {
    const {gettext, interpolate} = useI18n();
    const {formatNumber} = useFormatNumber();

    return (
        <section className={styles.container}>
            <p className={styles.description}>
                {interpolate(
                    gettext(
                        'Trusted by over %(no_of_companies)s companies and millions of learners around the world.',
                    ),
                    {no_of_companies: formatNumber(APPROX_COMPANY_COUNT)},
                    true,
                )}
            </p>
            <div className={styles['partner-logos']}>
                {PARTNER_LOGOS.map(({src, alt, width, height}) => (
                    <Image
                        key={alt}
                        className={styles['partner-logo']}
                        src={src}
                        alt={gettext(alt)}
                        width={width}
                        height={height}
                        loading="lazy"
                    />
                ))}
            </div>
        </section>
    );
}
